function AdminProduto() {
    return (
        <div>Admin perfil</div>
    )
}

export default AdminProduto